import uiTextWithSelectArea from './text-with-select-area/index.vue'
import uiUtilInputButton from './input-button/index.vue'
import uiUtilBoxTextSlot from './box-text-slot/index.vue'

export { uiTextWithSelectArea, uiUtilInputButton, uiUtilBoxTextSlot }
